import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  overflow-y: hidden;

  @media(min-width: 768px) {
    margin-top: 2rem;

    .display-header {
      display: none;
    }
  }
`;

export const PlayerContent = styled.div`
  @media(max-width: 770px) {
    width: 100%;
    padding-top: 20px;
  }

  @media(min-width: 770px) {
    width: 640px;
    height: 360px;
    margin: 0 auto;
  }
`;

export const HtmlContent = styled.div`
  overflow-y: scroll;

  &::-webkit-scrollbar-thumb {
      border: 5px solid transparent;
      border-radius: 100px;
      background-color: #8070d4;
      background-clip: content-box;
  }

  &::-webkit-scrollbar-track {
    border: 5px solid transparent;
    border-radius: 100px;
    background-color: #8070d4;
    background-clip: content-box;
  }

  &::-webkit-scrollbar {
    border: 5px solid transparent;
    border-radius: 100px;
    background-color: #8070d4;
    background-clip: content-box;
  }

  @media(max-width: 770px) {
    width: 100%;
    padding-top: 20px;
  }

  @media(min-width: 770px) {
    width: 640;
    margin: 0 auto;
  }
`;

export const CloseIcon = styled.div`
  font-size: 28px;
  color: #808080;
  cursor: pointer;
`;

export const PageTitleContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 4rem;

  @media(max-width: 768px) {
    margin-top: 1rem;
    padding: 0px 20px;
  }

  @media (max-width: 1015px){
    justify-content: flex-end;
  }
`;

export const PageIcon = styled.img`
  width: 24px;
  height: 21px;
  margin-right: 15px;
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const PageContent = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const VideosContainer = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  height: 95%;
  width: 100%;
  padding: 0px 7rem;
  margin-top: 2rem;

  @media (max-width: 768px){
    padding: 0px 1rem;
  }
`;

export const NextPage = styled.span`
  color: #000FFF;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
`;

export const NextPageContainer = styled.div`
  display: flex;
  justify-content: ${(props) => props.content};
  margin-bottom: 1.5rem;
  color: #000FFF;
`;

export const Search = styled.input`
  box-shadow: 0px 1px 2px #00000034;
  border: 0.5px solid #949494;
  border-radius: 18px;
  width: 493px;
  height: 35px;
  padding: 0px 20px;
  @media (max-width: 768px){
    width: 100%;
  }
`;

export const SearchIcon = styled.img`
  margin-left: -30px;
  margin-top: 10px;
  position: absolute;
  width: 15px;
  height: 15px;
`;

export const SearchBox = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 1015px){
    margin-top: 20px;
  }
  @media (max-width: 768px){
    width: 100%;
  }
`;

export const SearchTags = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: 768px){
    margin-top:10px;
  }
`;

export const SearchTag = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 20px;
  border: 1px solid #D5D5D5;
  padding: 5px 13px;
  color: #808080;
  margin-right: 19px;
  opacity: ${props => (props.opacity) ? '0.5' : '1'};
  &:hover {
    cursor: pointer;
  }
`;

export const SearchTagClose = styled.div`
  margin-left: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  background: #808080;
  color: #FFF;
  text-align: center;
  font-size: 10px;
  border-radius: 30px;
`;

export const TagsBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  @media (min-width: 768px){
    display: ${props => (props.mobile) ? 'none' : 'flex'};
  }
  @media (max-width: 768px){
    display: ${props => (props.desktop) ? 'none' : 'flex'};
    flex-wrap: wrap;
    padding: 0px;
    margin-bottom: 0px;
  }
`;

export const Tag = styled.div`
  padding: 3px 12px;
  color: ${props => (props.selected) ? '#FFF' : '#B2B2B2'};
  background: ${props => (props.selected) ? '#000FFF' : '#FFF'};
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 20px;
  margin-right: 21px;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 768px){
    margin-bottom: 10px;
  }
`;

export const HeaderIcon = styled.i`
  font-size: 29px;
  color: #ffffff;
`;

export const HeaderText = styled.span`
  font-size: 15px;
  color: #ffffff;
`;

export const Video = styled.div`
  margin-top: 20px;
  width: 100%;
  height: 350px;
  background: #B2B2B2;

  @media(max-width: 768px){
    height: 235px;
    margin-bottom: 10px;
    display: ${props => (props.mobile) ? 'block' : 'none'};
  }

  @media (min-width: 768px){
    display: ${props => (props.desktop) ? 'block' : 'none'};
  }
`
export const Module = styled.div`
  font-weight: 100;
  margin-top: 23px;
  color: #808080;
  font-size: 11px;
  @media(max-width: 768px){
    margin-top: 0px;
  }
`
export const Title = styled.div`
  color: #808080;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
  @media(max-width: 768px){
    margin-top: 2px;
    margin-bottom: 8px;
  }
`
export const Time = styled.div`
  font-weight: 100;
  font-size: 15px;
  color: #808080;
`

export const Description = styled.div`
  color: #707070;
  font-size: 14px;
  font-weight: 200;
  margin-top: 15px;
`

export const Actions = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${(props) => {
    if(props.initial) {
      return "flex-end"
    } else if(props.final) {
      return "flex-start"
    } else {
      return "space-between"
    }
  }};
  align-items: center;
  margin-top: 20px;
`

export const ActionsIcon = styled.i`
  width: 12px;
  height: 12px;
  margin-right: 5px;
`

export const ActionsButton = styled.div`
  color: #808080;
  font-weight: 100;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #808080;
  border-radius: 7px;
  padding: 8px 9px;
`

export const DivisionDesktop = styled.div`
  @media(min-width: 768px) {
    max-width: 640px;
    margin: 1rem auto 0 auto;
  }
`;
